"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreConfig = void 0;
exports.CoreConfig = {
    logLevel: {
        name: 'logLevel',
        defaultValue: 'info',
    },
    buidEnvironment: {
        name: 'buidEnvironment',
        defaultValue: 'browser',
    },
    defaultNetwork: {
        name: 'defaultNetwork',
        defaultValue: 'Evm',
    },
};
//# sourceMappingURL=CoreConfig.js.map